/**
 * Enum class for easy handling of local icons (/public/img), such as SVGs and similar,
 * that cannot come from figma due to colour restrictions or others.
 */
export enum CustomLocalIconName {
  SFX_LOGO = "sfx-logo",
  SAMMY_BIG = "sammy-big",
  SAMMY_SMALL = "sammy-small",
  GOOGLE_LOGO = "google-logo",
  MICROSOFT_LOGO = "microsoft-logo",
  ISSUE_SUPERSEDE = "supersede-issue",
  WIZARD = "wizard",
  WIZARD_WHITE = "wizard-white",
  RADIO_ON = "radio-on",
  RADIO_OFF = "radio-off",
}
